var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import CurrencyInput from 'components/CurrencyInput.vue';
import { mixpanelTracking } from '@/services/mixpanel';
import { formatCurrency } from '@/shared/utils/helpers';
let CapitalSocial = class CapitalSocial extends Vue {
    constructor() {
        super(...arguments);
        this.hasError = false;
    }
    inputsValidations() {
        let reseted = false;
        reseted =
            (this.selectedInputRange.value_start ===
                this.selectedInputRange.value_end &&
                this.selectedInputRange.value_end === null) ||
                this.selectedInputRange.value_end === '';
        if (reseted)
            this.resetValidationInputs();
        const inputInitialValidate = 
        // @ts-ignore
        this.$refs.inputInitialValue.validate();
        // @ts-ignore
        const inputEndValidate = this.$refs.inputEndValue.validate();
        this.hasError = (!inputInitialValidate || !inputEndValidate) && !reseted;
        return reseted || (inputInitialValidate && inputEndValidate);
    }
    resetValidationInputs() {
        // @ts-ignore
        this.$refs.inputInitialValue.resetValidation();
        // @ts-ignore
        this.$refs.inputEndValue.resetValidation();
    }
    formatNumber(number) {
        if (!number)
            return 0;
        return Number(number
            .replace(/\./g, '') // remove milhares
            .replace(',', '.') // troca vírgula por ponto
        );
    }
    clearFilter() {
        const cleared = {
            value_start: null,
            value_end: null,
        };
        this.selectedInputRange = cleared;
        this.selectedInputRange.value_start = null;
        this.selectedInputRange.value_end = null;
        this.$emit('setInputsRange', cleared);
        this.resetValidationInputs();
        this.hasError = false;
    }
    get selectedInfo() {
        if (this.selected)
            if (!this.hasError) {
                return `(selecionado: ${formatCurrency(this.selectedInputRange.value_start)} a ${formatCurrency(this.selectedInputRange.value_end)})`;
            }
            else
                return '<span class="font-12 text-red-8 text-weight-bold">Erro no filtro</span>';
        return '';
    }
    updated() {
        if (this.inputsValidations())
            this.$emit('setInputsRange', this.selectedInputRange);
    }
    valueIsNotEmpty(val) {
        return (val !== undefined &&
            (this.selectedInputRange.value_end !== null ||
                this.selectedInputRange.value_start !== null) &&
            val !== '');
    }
    handleTrackingCapitalSocial() {
        mixpanelTracking('filtros avançados: Expandiu o grupo de filtros: ' + this.filterName);
    }
};
__decorate([
    Prop({ default: '' })
], CapitalSocial.prototype, "filterName", void 0);
__decorate([
    PropSync('selectedInputRangeValues', { default: {} })
], CapitalSocial.prototype, "selectedInputRange", void 0);
__decorate([
    Prop({ default: 0 })
], CapitalSocial.prototype, "selected", void 0);
CapitalSocial = __decorate([
    Component({
        components: {
            CurrencyInput,
        },
    })
], CapitalSocial);
export default CapitalSocial;
